import { useEffect } from "react";

/** Helpers */
import { GenerateMeta } from "@/src/_common/useHelper";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "react-i18next";

/** Nextjs */
import { useRouter } from "next/router";

/** MUI */
import { NoSsr } from "@mui/material";

/** Redux */
import { getFetched, setFetched, setPrediction } from "@/src/_appStore/DB_Common";
import {
    fetchChartsFiltersFromIndexedDB,
    fetchDATESFromIndexedDB,
    fetchDBCommonFromIndexedDB,
    fetchJTFromIndexedDB,
    fetchListsTableFromIndexedDB,
    fetchRepositoryromIndexedDB,
    fetchSettingsChartBarsFromIndexedDB,
    fetchSettingsTableFromIndexedDB,
    fetchTableFiltersFromIndexedDB,
    fetchWSKFromIndexedDB,
} from "@/src/_appStore/utils/fetch";
import { useDispatch, useSelector } from "react-redux";

/** UI */
// const BazaDanychV2Index = dynamic(() => import("@/src/pages/BazaDanychPageV2/BazaDanychIndex"));
import BazaDanychV2Index from "@/src/pages/BazaDanychPageV2/BazaDanychIndex";
// const BazaDanychLayout = dynamic(() => import("@/src/layouts/BazaDanychLayout/BazaDanychLayout"));
import MetaHeadSEO from "@/src/_common/MetaHeadSEO";
import PagePreloader from "@/src/_common/PagePreloader";
import BazaDanychLayout from "@/src/layouts/BazaDanychLayout/BazaDanychLayout";

const BazaDanychPage = (props) => {
    const { metaTitle, metaDescription } = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const router = useRouter();

    // process.env.NODE_ENV === "development" && console.log(`%c BazaDanychPage `, "background: #000; color: #FFF;");

    const _fetched = useSelector(getFetched);

    useEffect(() => {
        if (_fetched) return;

        Promise.all([
            dispatch(fetchChartsFiltersFromIndexedDB()),
            dispatch(fetchDATESFromIndexedDB()),
            dispatch(fetchDBCommonFromIndexedDB()),
            dispatch(fetchJTFromIndexedDB()),
            dispatch(fetchListsTableFromIndexedDB()),
            dispatch(fetchSettingsChartBarsFromIndexedDB()),
            dispatch(fetchSettingsTableFromIndexedDB()),
            dispatch(fetchTableFiltersFromIndexedDB()),
            dispatch(fetchWSKFromIndexedDB()),
            dispatch(fetchRepositoryromIndexedDB()),
        ])
            .then((res) => {
                dispatch(setFetched(true));
            })
            .catch(
                (err) => process.env.NODE_ENV === "development" && console.log("%c DB: error", "background:#F00", err)
            )
            .finally(() => {});
    }, [_fetched]);

    useEffect(() => {
        return () => {
            // process.env.NODE_ENV === "development" &&
            //     console.log(`%c BazaDanychPage leave `, "background: #000; color: #0F0;");
            dispatch(setPrediction({ table: { _accepted: true }, chart: { _accepted: true } }));
        };
    });

    return (
        <BazaDanychLayout fetched={_fetched}>
            {(router?.query?.id || !_fetched) && <PagePreloader />}

            <MetaHeadSEO metaTitle={metaTitle} metaDescription={metaDescription} />
            <NoSsr>{_fetched ? <BazaDanychV2Index /> : ""}</NoSsr>
        </BazaDanychLayout>
    );
};

export async function getStaticProps(props) {
    const { locale } = props;
    const _metas = GenerateMeta({ pageId: "dbFull", locale });
    const { metaTitle, metaDescription } = _metas || {};

    return {
        props: {
            metaTitle,
            metaDescription,
            ...(await serverSideTranslations(locale, ["common"])),
            namespacesRequired: ["common"],
        },
        revalidate: false,
    };
}

export default BazaDanychPage;
